import { Pipe, PipeTransform } from '@angular/core';
import { AppVisibilityStatus, LocationAppVisibility } from 'src/app/features/charging-station-location/charging-station-location-model';

@Pipe({
  name: 'translateLocationStatusEnum',
})
export class TranslateLocationStatusEnum implements PipeTransform {
  transform(value: AppVisibilityStatus): string;
  transform(
    value: Array<{ index: number | string; name: number | string; value: number | string; label: number | string }>
  ): Array<{ index: number | string; name: string; value: number | string; label: string }>;
  transform(
    value: AppVisibilityStatus | Array<{ index: number | string; name: number | string; value: number | string; label: number | string }>
  ): string | Array<{ index: number | string; name: string; value: number | string; label: string }> {
    if (Array.isArray(value)) {
      return value.map(item => ({
        // Old properties for backward compatibility
        index: item.index,
        name: APP_VISIBILITY_STATUS_NAMES[item.value] || String(item.value),
        // New properties
        value: item.value,
        label: APP_VISIBILITY_STATUS_NAMES[item.value] || String(item.value),
      }));
    }

    return APP_VISIBILITY_STATUS_NAMES[value] || String(value);
  }
}

@Pipe({
  name: 'translateLocationAppVisibility',
})
export class TranslateLocationAppVisibilityPipe implements PipeTransform {
  transform(value: LocationAppVisibility | null | undefined): string {
    return LOCATION_APP_VISIBILITY_NAMES[value ?? ''] ?? String(value ?? '');
  }
}

const APP_VISIBILITY_STATUS_NAMES: Record<string, string> = {
  Hidden: 'Skjult',
  Coming: 'Kommende',
  Restrictions: 'Synlig med OBS!',
  Visible: 'Synlig',
};
const LOCATION_APP_VISIBILITY_NAMES: Record<string, string> = {
  Both: 'Både erhvervsappen og den offentlige app',
  Commercial: 'Erhvervsappen',
  Public: 'Den offentlige app',
};
